export const reasonOptions = [
  'Image Not Visible Properly',
  'Not A Valid Document',
  'Document Validation Expired',
  'Add Custom Reason'
]

export const tableHeaders = [
  { label: 'Id', value: 'userBonusId' },
  { label: 'Promotion Title', value: 'promotionTitle' },
  { label: 'Bonus Type', value: 'bonusType' },
  { label: 'Valid Till', value: 'validTo' },
  { label: 'Is Expired', value: 'isExpired' },
  { label: 'Status', value: 'isActive' },
  { label: 'Issued By', value: 'issuerRole' },
  { label: 'Issued At', value: 'createdAt' },
  { label: 'Amount To Wager', value: 'amountToWager' },
  { label: 'Wagered Amount', value: 'wageredAmount' },
  { label: 'Cancelled By', value: 'cancelledBy' },
  { label: 'Updated At', value: 'updatedAt' },
  { label: 'Action', value: 'action' }
]

export const tableHeadersRefferal = [
  { label: 'Id', value: 'userId' },
  { label: 'UserName', value: 'username' },
  { label: 'Email', value: 'email' },
  //   { label: 'First Name', value: 'firstName' },
  //   { label: 'Date Of Birth', value: 'dateOfBirth' },
  { label: 'Phone Number', value: 'phoneNumber' },
  { label: 'Status', value: 'status' },
  { label: 'host', value: 'host' },
  // { label: 'is internal', value: 'is internal' },
  //   { label: 'affiliate name', value: 'affiliate name' },
  //   { label: 'affiliate status', value: 'affiliate status' },
]

export const bonusStatus = [
  { label: 'All', value: '' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Cancelled', value: 'CANCELLED' },
  { label: 'Forfeited', value: 'FORFEITED' },
  { label: 'Expired', value: 'EXPIRED' },
  { label: 'Completed', value: 'COMPLETED' }
]

export const bonusTypes = [
  { label: 'All', value: '' },
  { label: 'MATCH', value: 'match', id: 0 },
  { label: 'BALANCE', value: 'balance', id: 1 },
  { label: 'FREESPINS', value: 'freespins', id: 2 },
  { label: 'DEPOSIT(CASHBACK)', value: 'deposit', id: 4 },
  { label: 'WAGERING(CASHBACK)', value: 'wagering', id: 5 }
]

export const affiliateList = [
  { label: 'Parent Affiliate ID', value: 'parentIdAffiliate' },
  { label: 'Parent Username', value: 'parentUsername' },
  { label: 'Affiliate ID', value: 'affiliateId' },
  { label: 'User Name', value: 'username' },
  { label: 'First Name', value: 'firstName' },
  { label: 'Last Name', value: 'lastName' },
  { label: 'Email', value: 'email' },
  { label: 'Country', value: 'country' },
  { label: 'Currency', value: 'currency' },
  { label: 'Mobile', value: 'mobile' }
]

export const userDisableReasons = [
  'Bonus abuser',
  'Duplicate account',
  'Fraudulent',
  'Risk country',
  'Rude behaviour',
  'Bannec country - connect with VPN or Tor Browser',
  'Suspicios - constant deposits and withdrawals (money laundering)',
  'Contacts support for bigger amount of deposit than allowed',
  'Resonsible Gambling',
  'validated',
  'Other'
]

export const emailTempaltesConstants = {
  'Active User': 'ACTIVE_USER',
  'In-Active User': 'IN_ACTIVE_USER',
  'Email Verification': 'EMAIL_VERIFICATION',
  'Reset Password': 'RESET_PASSWORD',
  'KYC Rejected': 'KYC_REJECTED',
  'KYC Verified': 'KYC_VERIFIED',
  'KYC Requested': 'KYC_REQUESTED',
  'KYC Reminder': 'KYC_REMINDER',
  'KYC Received': 'KYC_RECEIVED',
  'Withdraw Request Received': 'WITHDRAW_REQUEST_RECEIVED',
  'Withdraw Approved': 'WITHDRAW_APPROVED',
  'Withdraw Processed': 'WITHDRAW_PROCESSED',
  'Deposit Success': 'DEPOSIT_SUCCESS',
  'Deposit Failed': 'DEPOSIT_FAILED',
  'Registration Welcome': 'REGISTRATION_WELCOME',
  'Gambling Status Registration': 'GAMBLING_STATUS_REGISTRATION',
  'Password Updated': 'UPDATE_PASSWORD',
  'Joining Bonus': 'JOINING_BONUS',
  'Referral Bonus': 'REFERRAL_BONUS',
  'Host Rejected': 'HOST_REJECTED',
  'Forgot Password': 'FORGOT_PASSWORD',
  'Deposit Request Received': 'DEPOSIT_REQUEST_RECEIVED',
  'Host Approved': 'HOST_APPROVED',
  "We have got a new Deposit Request " : "We have got a new Deposit Request",
  "Profile Verification Code": "PROFILE_VERIFICATION_CODE",
  "Deposit Request Received": "DEPOSIT_REQUEST_RECEVIED",
  "Withdraw Failed": "WITHDRAW_FAILED",
  "Deposit Approved": "DEPOSIT_APPROVED",
  'We have got a new Deposit Request': 'WE_HAVE_GOT_A_NEW_DEPOSIT_REQUEST',
  'We have got a new Withdrawal Request': 'WE_HAVE_GOT_A_NEW_WITHDRAWAL_REQUEST',
  'Comeback Bonus': 'COMEBACK_BONUS',
  'Day 3 No Deposit': 'DAY_3_NO_DEPOSIT',
  'Day 3 No Deposit Bonus Offer': 'DAY_3_NO_DEPOSIT_BONUS_OFFER'


}

export  const EMAIL_TEMPLATE_HIDDEN = ["We have got a new Deposit Request" , "We have got a new Withdrawal Request"]


// ACTIVE_USER: 'Active User',
//   IN_ACTIVE_USER: 'In-Active User',
//   EMAIL_VERIFICATION: 'Email Verification',
//   RESET_PASSWORD: 'Reset Password',
//   HOST_REJECTED: 'Host Rejected',
//   HOST_APPROVED: 'Host Approved',
//   KYC_REQUESTED: 'KYC Requested',
//   KYC_REMINDER: 'KYC Reminder',
//   KYC_RECEIVED: 'KYC Received',
//   WITHDRAW_REQUEST_RECEIVED: 'Withdraw Request Received',
//   WITHDRAW_APPROVED: 'Withdraw Approved',
//   DEPOSIT_APPROVED: 'Deposit Approved',
//   WITHDRAW_PROCESSED: 'Withdraw Processed',
//   WITHDRAW_FAILED: 'Withdraw Failed',
//   DEPOSIT_REQUEST_RECEVIED: 'Deposit Request Received',
//   DEPOSIT_SUCCESS: 'Deposit Success',
//   DEPOSIT_FAILED: 'Deposit Failed',
//   REGISTRATION_WELCOME: 'Registration Welcome',
//   GAMBLING_STATUS_REGISTRATION: 'Gambling Status Registration',
//   UPDATE_PASSWORD: 'Password Updated',
//   JOINING_BONUS: 'Joining Bonus',
//   FORGOT_PASSWORD: 'Forgot password',
//   PROFILE_VERIFICATION_CODE: 'Profile Verification Code',